export default "__VITE_ASSET__D8S334aJ__"